import React from "react";
import CategoriesSection from "../components/CategoriesSection";
import InnerHero from "../components/InnerHero";
import products from "../data/products";
import ProductDetailsSection from "../components/ProductOverview";
import CTASection from "../components/CTASection";


const ProductDetails = ({ id }) => {
    const product = products.find(p => p.id === id);

    return (
        <>
            <InnerHero
                title="Product Details"
                subtitle="Powerful insecticide for effective control of harmful pests and improved crop health."
                breadcrumb="Home"
                bgImage="/images/img/hero.jpg"
                size="mini"
            />
            <CategoriesSection />
            <ProductDetailsSection products={products} />
            <CTASection />
        </>
    );
};
export default ProductDetails;